import EventEmitter3 from 'eventemitter3';

/** 路由跳转事件携带的参数 */
export interface NavigatePayload {
  /** 目标路径，使用 PagePath 枚举值，如 '/reports' */
  path: string;
  /** 可选：navigation state，目标页面通过 useLocation().state 读取 */
  state?: Record<string, unknown>;
}

/** navEmitter 支持的事件类型映射 */
export interface NavEvents {
  /** 触发 SPA 路由跳转 */
  navigate: NavigatePayload;
}

/**
 * 全局导航事件总线单例。
 *
 * 用于在 React 渲染树之外（如 Zustand store）触发路由跳转，
 * 避免在非 React Router Provider 上下文中直接调用 useNavigate。
 *
 * 使用方式（派发端）：
 * ```ts
 * import { navEmitter } from '@/utils/nav-emitter';
 * navEmitter.emit('navigate', { path: '/reports', state: { tab: 'saved' } });
 * ```
 *
 * 使用方式（监听端，须在 RouterProvider 内）：
 * ```ts
 * import { useNavEmitterListener } from '@/hooks/useNavEmitterListener';
 * useNavEmitterListener(); // 在顶层 Layout 调用
 * ```
 */
export const navEmitter = new EventEmitter3<NavEvents>();
